<template>
    <div>
        <div v-for="(positionList, i) in playerList" :key="i">
          <div class='section-title'>{{ playerPosition[positionList.position] }}</div>
          <div id='position-list-player-list'>
              <playerItem v-for='(item) in positionList.list' :key="item.playerId" :player='item'/>
          </div>
        </div>
        <hr/>
        <loadStateView :state="netState" :refreshHandle="refreshData"/>
    </div>
</template>

<script>
import playerItem from '../components/playerItem'

export default {
  name: 'position-list',
  components: {
    playerItem
  },
  props: {
    teamInfoForRoute: {
      type: Object,
      default () {
        return {}
      }
    },
    teamId: {
      type: String,
      required: true
    }
  },
  watch: {
    teamId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadData()
      }
    }
  },
  mounted () {
    this.loadData()
    if (this.$route.params.teamInfoForRoute && this.$route.params.teamInfoForRoute.coachName) {
      this.teamInfo = this.$route.params.teamInfoForRoute
    }
  },
  activated () {
    this.loadData()
    if (this.$route.params.teamInfoForRoute && this.$route.params.teamInfoForRoute.coachName) {
      this.teamInfo = this.$route.params.teamInfoForRoute
    }
  },
  methods: {
    loadData: function () {
      this.netState = this.playerList.length > 1 ? 0 : 1
      this.$ft_getTeamPlayerList(this.$route.params.teamId).then(result => {
        if (result.netState === 2) {
          this.netState = result.netState
          return
        }

        var playerList = []
        // 构建教练对象
        if (this.teamInfo.coachName) {
          var coach = {
            position: 4,
            list: [{ position: 4, playerName: this.teamInfo.coachName, playerEngName: this.teamInfo.coachEngName, playerId: this.teamInfo.coachId, teamId: this.teamInfo.teamId }]
          }
          playerList.push(coach)
        }
        // 筛选球员
        result.list.forEach((item, index, array) => {
          let position = item.position
          let foundItem = playerList.filter(item2 => item2['position'] === position)
          if (foundItem.length === 0) {
            playerList.push({
              position: position,
              list: [item]
            })
          } else {
            foundItem[0].list.push(item)
          }
        })
        this.playerList = playerList
        this.netState = this.playerList.length > 1 ? 0 : 3
      }).catch((error) => {
        this.netState = 2
        console.log('error:', error)
      })
    },
    refreshData () {
      this.loadData()
    },
    rowCount: function (index) {
      return Math.ceil(this.playerList[index].list.length / 2)
    }
  },
  data () {
    return {
      teamInfo: this.teamInfoForRoute,
      playerList: { position: 0, list: [] },
      playerPosition: [
        this.$t('lineUp.forward'),
        this.$t('lineUp.centerForward'),
        this.$t('lineUp.guard'),
        this.$t('lineUp.goalkeeper'),
        this.$t('lineUp.coach')
      ],
      netState: 0
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~@/styles'

#position-list-player-list
  display: flex
  flex-wrap: wrap

.divider
  border-bottom: 1px solid #dcdcdc
hr
    width: 100%
    padding-bottom: 20px
</style>
